var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({ref:"field",attrs:{"value":_vm.formattedValue},on:{"input":_vm.onInput}},'el-input',_vm.$attrs,false),[_c('template',{slot:"prepend"},[_vm._t("prepend")],2),_c('template',{slot:"append"},[_vm._t("append")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }